// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"ForgotPasswordFinished__wrapper___1Zssp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/ForgotPasswordFinished.scss
// module id = dJFn
// module chunks = 0